import { useTranslation } from "react-i18next";
import Card from "../../../../../components/ui/Card";
import { RestaurantTheme } from "../../../../../types/restaurant";
import { ThemeType } from "../../../../../types/custom";
import { Branch } from "../../../../../utils/supabaseClient";

type LayoutSettingsProps = {
	restaurant: Branch | null;
	updateTheme: (updates: Partial<RestaurantTheme>) => void
}

const LayoutSettings: React.FC<LayoutSettingsProps> = ({ restaurant, updateTheme }) => {
	const { t } = useTranslation();

	// useEffect(() => {
	// 	if (restaurant && !restaurant.theme) {
	// 		updateTheme({ cardStyle: 'minimal', headerStyle: 'transparent' })
	// 	}
	// }, [restaurant])

	return <div className="space-y-6">
		<Card>
			<h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
				{t('settings.menuLayout')}
			</h3>
			<div className="space-y-4">
				<div>
					<label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
						{t('settings.menuStyle')}
					</label>
					<div className="flex gap-3">
						{(['grid', 'list'] as const).map((style) => (
							<button
								key={style}
								onClick={() => updateTheme({ menuStyle: style })}
								className={`px-4 py-2 rounded-md border transition-colors cursor-pointer ${(restaurant?.theme as ThemeType)?.menuStyle === style
									? 'border-primary bg-primary/10 text-primary'
									: 'border-gray-300 dark:border-gray-600 hover:border-gray-400'
									}`}
							>
								{t(`settings.menuStyles.${style}`)}
							</button>
						))}
					</div>
				</div>

				<div>
					<label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
						{t('settings.SubcategoryStyle')}
					</label>
					<div className="flex gap-3">
						{(['tabs', 'dropdown'] as const).map((style) => (
							<button
								key={style}
								onClick={() => updateTheme({ SubcategoryStyle: style })}
								className={`px-4 py-2 rounded-md border transition-colors cursor-pointer ${(restaurant?.theme as ThemeType)?.SubcategoryStyle === style
									? 'border-primary bg-primary/10 text-primary'
									: 'border-gray-300 dark:border-gray-600 hover:border-gray-400'
									}`}
							>
								{t(`settings.SubcategoryStyles.${style}`)}
							</button>
						))}
					</div>
				</div>

				<div>
					<label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
						{t('settings.menuSortType')}
					</label>
					<div className="flex gap-3 flex-wrap">
						{(['manual', 'alphabetic', 'time'] as const).map((sortType) => (
							<button
								key={sortType}
								onClick={() => updateTheme({ menuSortType: sortType })}
								className={`px-4 py-2 rounded-md border transition-colors cursor-pointer ${((restaurant?.theme as ThemeType)?.menuSortType ?? 'manual') === sortType
									? 'border-primary bg-primary/10 text-primary'
									: 'border-gray-300 dark:border-gray-600 hover:border-gray-400'
									}`}
							>
								{t(`settings.menuSortTypes.${sortType}`)}
							</button>
						))}
					</div>
					{((restaurant?.theme as ThemeType)?.menuSortType ?? 'manual') === 'manual' && (
						<p className="mt-2 text-xs text-primary/80 dark:text-primary/70">
							{t('settings.dragToReorder')} — {t('settings.menuSortTypes.manual')}
						</p>
					)}
				</div>
			</div>
		</Card>

		<Card>
			<h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
				{t('settings.borderRadius')}
			</h3>
			<div className="flex flex-col sm:flex-row sm:items-center flex-wrap gap-3">
				{[
					{ label: 'None', value: '0' },
					{ label: 'Small', value: '0.25rem' },
					{ label: 'Medium', value: '0.5rem' },
					{ label: 'Large', value: '1rem' },
					{ label: 'Extra Large', value: '1.5rem' }
				].map((option) => (
					<button
						key={option.value}
						onClick={() => updateTheme({ borderRadius: option.value })}
						className={`px-4 py-2 text-nowrap rounded-md border transition-colors cursor-pointer ${(restaurant?.theme as ThemeType)?.borderRadius === option.value
							? 'border-primary bg-primary/10 text-primary'
							: 'border-gray-300 dark:border-gray-600 hover:border-gray-400'
							}`}
					>
						{option.label}
					</button>
				))}
			</div>
		</Card>
	</div>
};

export default LayoutSettings;
